<template>
  <div id="app">
    <app-header />
    <router-view/>
    <app-footer-top />
    <app-footer-bottom />
  </div>
</template>

<script>
import Header from "@/views/header/header.vue"
import FooterTop from "@/views/footer/footer-top.vue"
import FooterBottom from "@/views/footer/footer-bottom.vue"
import {mapGetters} from 'vuex';

export default {
  name: "app",
  components: {
    'app-header': Header,
    'app-footer-top': FooterTop,
    'app-footer-bottom': FooterBottom
  },
  created: function(){
    this.$store.dispatch('checkTenant');
  },
  mounted: function() {
    console.log("Hello Jquery");
    console.log($);
    $("h1").text("Now is the time for all good men to follow the rules ...");

    $('.burger-menu').click(function(){    
        $('.slidebarmenu').toggleClass('opened');  
        $('.overl').toggleClass('over-on'); 
    });

    $('.overl, .sidebar-close').click(function () {
        $('.slidebarmenu').removeClass('opened');  
        $('.overl').removeClass('over-on');
    });

	  $('.panel-collapse').on('show.bs.collapse', function () {
        $(this).siblings('.panel-heading').addClass('active');
    });

    $('.panel-collapse').on('hide.bs.collapse', function () {
        $(this).siblings('.panel-heading').removeClass('active');
    });

  },
  computed: {
    ...mapGetters([
        'tenantId',
        'subDomain',
        'businessId',
        'businessName',    
        'businessType',
        'businessWebsiteUrl',
        'loading',
        'loadingMessage',
        'error',
        'errorMessage'
    ]),
    tenantIdCheck:function(){
      return this.$store.getters.tenantId;
    }
  },
  watch: {
    tenantIdCheck (newVal, oldVal) {
      console.log(`We have ${newVal} now, yaay!`)
      if(newVal != ""){
        let lcid = "";
        let prid = "";

        if(this.$route.params.locid){
          console.log('If locid not in route = ' + this.$route.params.locid)
          localStorage.setItem("locationId", JSON.stringify(this.$route.params.locid)); 
          lcid = this.$route.params.locid;
        }else{
          lcid =  JSON.parse(localStorage.getItem("locationId"));
        }
        
        if(this.$route.params.staffid){
          localStorage.setItem("providerId", JSON.stringify(this.$route.params.staffid)); 
          prid = this.$route.params.staffid;
        }else{
          prid =  JSON.parse(localStorage.getItem("providerId"));
        }

        this.$store.dispatch('getBusinessSetup', newVal);
        this.$store.dispatch('getLocation', {"x_tenant_id": newVal, "locationId": lcid});
        this.$store.dispatch('getStaff', {"x_tenant_id": newVal, "staffId": prid});
      }
    }
  }
};
</script>

<style src="@/assets/styles/common-style.css">
</style>
